import React from 'react'
import Main from '../../../components/HOC/Main'
import { NAVIGATION } from '../../../lib/navigation'
import BlogsForm from '../../../components/pages/BlogsForm'

const AddBlogPage = () => {
    return (
        <Main crumbs={[{ title: "blog" }, { title: "blogs", href: NAVIGATION.INNER_NAVIGATION.BLOGS.BLOGS }, { title: "add blog" }]}>
            <BlogsForm />
        </Main>
    )
}

export default AddBlogPage